/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import * as S from './styles';

export interface IHeroButtonProps {
  buttons: {
    key: string;
    title: string;
    color: 'primary' | 'secondary' | '';
  };
  onHeroButtonClick?(key: string): void;
}

export const HeroButtons = (props: IHeroButtonProps) => {
  const { buttons, onHeroButtonClick } = props;

  const onButtonClick = (key: any) => {
    onHeroButtonClick && onHeroButtonClick(key);
  };

  return (
    <S.ButtonContainer className="mb-3">
      {buttons?.map((item) => {
        return (
          <Button
            rounded
            onClick={() => onButtonClick(item?.key)}
            variant={item?.color}
            className="mx-2"
          >
            {item?.title}
          </Button>
        );
      })}
    </S.ButtonContainer>
  );
};

HeroButtons.defaultProps = {
  buttons: [],
};
